<template>
  <section class="privacy">
    <div class="container">
      <div class="privacy__wrapper col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
        <h1 class="privacy__title push-v--desktop--large push-v--tablet--large push-v--mobile--x-small">{{ title }}</h1>
        <div class="push-v--desktop--medium push-v--tablet--medium push-v--mobile--small">
          <p class="privacy__updated-title push-v--tablet--x-small push-v--mobile--x-small">{{ updatedText }}</p>
          <span class="privacy__subtitle text--faux push-v--mobile--small">{{ date }}</span>
        </div>
        <div v-html="body" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'Privacy policy' },
    updatedText: { type: String, default: 'Last updated' },
    subtitle: { type: String, default: 'what information do we collect?' },
    date: { type: String, default: '25 May 2018' },
    intro: {
      type: String,
      default: '',
    },
    introSecondary: {
      type: String,
      default: '',
    },
    mailto: { type: String, default: 'hello@thecollective.com' },
    body: {
      type: Array,
      default() {
        return [
          {
            body:
              '<p>The use of "The Collective", "we", "our" and "us" means The Collective (Living) Limited, a limited company registered in England & Wales with registration number 07271022. Our registered office is at 14 Bedford Square, London, WC1B 3JA.</p>',
          },
          {
            body:
              '<p>The use of "The Collective", "we", "our" and "us" means The Collective (Living) Limited, a limited company registered in England & Wales with registration number 07271022. Our registered office is at 14 Bedford Square, London, WC1B 3JA.</p>',
          },
          {
            body:
              '<p>The use of "The Collective", "we", "our" and "us" means The Collective (Living) Limited, a limited company registered in England & Wales with registration number 07271022. Our registered office is at 14 Bedford Square, London, WC1B 3JA.</p>',
          },
        ];
      },
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_privacy.scss';
</style>
